// Klientlagring för gratiskvot och övningsstatistik (per-enhet).
// Premium-status och inloggning hanteras av Lovable Cloud Auth + premium_access-tabellen.
//
// Gratismodell: 5 frågor per dag i högst 5 dagar. Den som lämnar sin e-post
// får dessutom 5 bonusfrågor direkt samma dag (totalt 10 första dagen).
// Startsidans snabbtest räknas mot samma kvot.

export const FREE_DAILY_LIMIT = 5;
export const EMAIL_BONUS = 5;
export const FREE_MAX_DAYS = 5;

const KEY_DATE = "ap.usage.date";
const KEY_COUNT = "ap.usage.count";
const KEY_DAYS = "ap.usage.days";
const KEY_BONUS = "ap.usage.bonusDate";
const KEY_ANSWERS = "ap.answers";

function today() {
  return new Date().toISOString().slice(0, 10);
}

function getDays(): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY_DAYS) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

export function getDailyCount(): number {
  if (typeof window === "undefined") return 0;
  if (localStorage.getItem(KEY_DATE) !== today()) {
    localStorage.setItem(KEY_DATE, today());
    localStorage.setItem(KEY_COUNT, "0");
    return 0;
  }
  return parseInt(localStorage.getItem(KEY_COUNT) || "0", 10);
}

export function incDailyCount() {
  const n = getDailyCount() + 1;
  localStorage.setItem(KEY_COUNT, String(n));
  const days = getDays();
  if (!days.includes(today())) {
    days.push(today());
    localStorage.setItem(KEY_DAYS, JSON.stringify(days.slice(-30)));
  }
  return n;
}

/** Har gratisperioden (5 dagar) tagit slut? */
export function freePeriodOver(): boolean {
  if (typeof window === "undefined") return false;
  const days = getDays();
  return days.length >= FREE_MAX_DAYS && !days.includes(today());
}

export function hasEmailBonus(): boolean {
  if (typeof window === "undefined") return false;
  return !!localStorage.getItem(KEY_BONUS);
}

/** Lås upp 5 bonusfrågor direkt (endast en gång per enhet). */
export function grantEmailBonus() {
  if (typeof window === "undefined") return;
  if (!localStorage.getItem(KEY_BONUS)) localStorage.setItem(KEY_BONUS, today());
}

export function todayLimit(): number {
  if (typeof window === "undefined") return FREE_DAILY_LIMIT;
  const bonusToday = localStorage.getItem(KEY_BONUS) === today();
  return FREE_DAILY_LIMIT + (bonusToday ? EMAIL_BONUS : 0);
}

export function remainingFree(): number {
  if (freePeriodOver()) return 0;
  return Math.max(0, todayLimit() - getDailyCount());
}

export type AnswerRecord = { id: string; correct: boolean; ts: number; category: string };

export function recordAnswer(rec: AnswerRecord) {
  if (typeof window === "undefined") return;
  const all: AnswerRecord[] = JSON.parse(localStorage.getItem(KEY_ANSWERS) || "[]");
  all.push(rec);
  localStorage.setItem(KEY_ANSWERS, JSON.stringify(all.slice(-500)));
}

export function getAnswers(): AnswerRecord[] {
  if (typeof window === "undefined") return [];
  return JSON.parse(localStorage.getItem(KEY_ANSWERS) || "[]");
}

export function clearAnswers() {
  localStorage.removeItem(KEY_ANSWERS);
}
